import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, computed, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue'
import { amplitudeLogEvent, amplitudeEvents } from '@shared/lib'
import { IBanksItem } from '@entities/banks/model/types'
import { useBanksModel } from '@entities/banks'
import { SearchByArray } from '@shared/ui'
import { BanksList } from '@entities/banks/ui'


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentAllBanks',
  props: {
  sbpModal: {
    type: Boolean as PropType<boolean>,
    required: true,
    default: false
  }
},
  emits: ['toggleBanksModal', 'pay'],
  setup(__props, { emit: emits }) {

const props = __props

const banksModel = useBanksModel()
const { $cookies } = useContext()





// Data
const searchBanks = ref<IBanksItem[]>([])
const search = ref<string>('')

// Methods
const setSearchBanks = (banksArray: IBanksItem[]) => {
  searchBanks.value = banksArray
  banksModel.filteredBanks = banksArray
}

const pay = (val: IBanksItem) => {
  amplitudeLogEvent(amplitudeEvents.CHOICE_BANK, { Банк: val.name })
  $cookies.set('selectedBank', val, {
    maxAge: 60 * 60 * 24 * 365
  })
  banksModel.resortBanks()
  emits('pay', val)
}

// Computed
const banks = computed(() => {
  const templateBankItem = { id: Date.now(), label: 'Популярные', banksInner: [...banksModel.banksFavorite] }
  return search.value.length ? banksModel.banksAlphabet : [templateBankItem, ...banksModel.banksAlphabet]
})

// Mounted
onMounted(() => {
  searchBanks.value = banksModel.banks
})

return { __sfc: true,banksModel, $cookies, props, emits, searchBanks, search, setSearchBanks, pay, banks, SearchByArray, BanksList }
}

})